import { z } from 'zod';
import { ALL_STAGES } from './pipeline.js';
/** Columns the importer understands (M2-06: accounts, contacts, opportunities, touch history). */
export const IMPORT_FIELDS = [
    { key: 'company', label: 'Company', required: true, group: 'Account' },
    { key: 'website', label: 'Website', required: false, group: 'Account' },
    { key: 'industry', label: 'Industry', required: false, group: 'Account' },
    { key: 'headcountBand', label: 'Headcount band', required: false, group: 'Account' },
    { key: 'location', label: 'Location', required: false, group: 'Account' },
    { key: 'icpCode', label: 'ICP code', required: false, group: 'Account' },
    { key: 'firstName', label: 'First name', required: true, group: 'Contact' },
    { key: 'lastName', label: 'Last name', required: false, group: 'Contact' },
    { key: 'title', label: 'Job title', required: false, group: 'Contact' },
    { key: 'persona', label: 'Persona', required: false, group: 'Contact' },
    { key: 'email', label: 'Email', required: false, group: 'Contact' },
    { key: 'phone', label: 'Phone', required: false, group: 'Contact' },
    { key: 'linkedinUrl', label: 'LinkedIn URL', required: false, group: 'Contact' },
    { key: 'dataSource', label: 'Data source', required: false, group: 'Contact' },
    { key: 'lawfulBasis', label: 'Lawful basis', required: false, group: 'Contact' },
    { key: 'status', label: 'Status / stage (legacy)', required: false, group: 'Pipeline' },
    { key: 'trigger', label: 'Trigger', required: false, group: 'Pipeline' },
    { key: 'nextActionAt', label: 'Next action date', required: false, group: 'Pipeline' },
    { key: 'nextActionNote', label: 'Next action', required: false, group: 'Pipeline' },
    { key: 'lastTouchAt', label: 'Last touch date', required: false, group: 'Touch history' },
    { key: 'lastTouchChannel', label: 'Last touch channel', required: false, group: 'Touch history' },
    { key: 'lastTouchOutcome', label: 'Last touch outcome', required: false, group: 'Touch history' },
];
export const DUPLICATE_STRATEGIES = ['skip', 'merge', 'overwrite'];
export const importOptionsSchema = z.object({
    /** CRM field → CSV header (or null when not mapped) */
    mapping: z.record(z.string(), z.string().nullable()),
    /** legacy Excel status value → funnel stage (M2-06); unmapped values become Identified */
    stageMap: z.record(z.string(), z.enum(ALL_STAGES)).default({}),
    /** M2-04: what to do when a contact already exists (email, LinkedIn URL, or company + name) */
    duplicateStrategy: z.enum(DUPLICATE_STRATEGIES).default('skip'),
    /** used when the file has no data-source column (M2-07: otherwise flagged for completion) */
    defaultDataSource: z.string().max(60).nullish(),
    defaultLawfulBasis: z.string().max(500).nullish(),
});
export const saveMappingSchema = z.object({
    name: z.string().trim().min(2).max(80),
    mapping: z.record(z.string(), z.string().nullable()),
    stageMap: z.record(z.string(), z.enum(ALL_STAGES)).default({}),
});
//# sourceMappingURL=import.js.map